import { Box, Container } from "@mui/material";
import React, { useEffect } from "react";
import { Base } from "../base";
import AddEditSiteForm from "../forms/AddEditSiteForm";
import { useDispatch, useSelector } from "../../store";
import { searchSiteManager } from "../../slices/siteManager";
import { searchSiteType } from "../../slices/siteType";
import { searchStates } from "../../slices/options";
import SearchParams, { defaultParams } from "../../types/searchParams";
import { editSite, getSiteId, postSite, resetSite } from "../../slices/site";
import { useNavigate, useParams } from "react-router-dom";
import { setAddedAttachments } from "../../slices/attachment";

interface Props {}

const AddEditSitePage: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { site } = useSelector((store) => store.site);

  useEffect(() => {
    dispatch(resetSite());
    dispatch(setAddedAttachments([]));
    dispatch(searchSiteManager(defaultParams));
    dispatch(searchSiteType(defaultParams));
    dispatch(searchStates(defaultParams));
    if (site.id !== +id!) {
      dispatch(getSiteId(+id!));
    }
  }, [dispatch]);

  const submitSite = (values: any) => {
    if (values.id > 0) {
      dispatch(
        editSite({
          ...values,
          address: {
            ...values.address,
            zipCode:
              values.address.zipCode === undefined
                ? undefined
                : `${values.address.zipCode}`,
          },
        })
      ).then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          navigate(-1);
        }
      });
    } else {
      dispatch(
        postSite({
          ...values,
          address: {
            ...values.address,
            zipCode:
              values.address.zipCode === undefined
                ? undefined
                : `${values.address.zipCode}`,
          },
        })
      ).then((result: any) => {
        if (result.meta.requestStatus === "fulfilled") {
          navigate(`/site/view/${result.payload.id}`);
        }
      });
    }
    dispatch(searchSiteType(defaultParams));
  };

  const handleSiteManagerSearch = (search: SearchParams) => {
    dispatch(
      searchSiteManager({
        query: search.query,
        pageNumber: 1,
        pageSize: 10,
      })
    );
  };

  const handleSiteTypeSearch = (search: SearchParams) => {
    dispatch(
      searchSiteType({
        query: search.query,
        pageNumber: 1,
        pageSize: 10,
      })
    );
  };

  const handleStateSearch = (search: SearchParams) => {
    dispatch(
      searchStates({
        query: search.query,
        pageNumber: 1,
        pageSize: 63,
      })
    );
  };

  return (
    <Box
      sx={{
        margin: { md: 5, xs: 0 },
        display: "flex",
        flexDirection: "column",
        gap: 3,
        height: "100%",
        pb: 5,
      }}
    >
      <Base.TitleBar title={site.id > 0 ? "Edit Site" : "Add New Site"} />
      <Container>
        <AddEditSiteForm
          apiSiteManagerSearch={handleSiteManagerSearch}
          apiSiteTypeSearch={handleSiteTypeSearch}
          apiStateSearch={handleStateSearch}
          submitSite={submitSite}
          resetSite={() => {
            dispatch(resetSite());
          }}
          handleCancel={() => navigate(-1)}
        />
      </Container>
    </Box>
  );
};

export default AddEditSitePage;
